import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface DocListState {
  docListId: number | null;
  showManageColumns: boolean;
  backSourceLabel: string | null;
  backSourcePath: string | null;
  backSourceSearchId: number | null;
  backSourceNavState: object | null;
  prevDocumentListMasterId: string;
}

const initialState: DocListState = {
  docListId: null,
  showManageColumns: false,
  backSourceLabel: null,
  backSourcePath: null,
  backSourceSearchId: null,
  backSourceNavState: null,
  prevDocumentListMasterId: '',
};

const docListSlice = createSlice({
  name: 'docList',
  initialState,
  reducers: {
    setDocListId(state, action: PayloadAction<number | null>) {
      state.docListId = action.payload;
    },
    setShowManageColumns(state, action: PayloadAction<boolean>) {
      state.showManageColumns = action.payload;
    },
    setDocListBackNavigation(
      state,
      action: PayloadAction<{
        label: string | null;
        path: string | null;
        searchId?: number | null;
        navState?: object | null;
      }>
    ) {
      state.backSourceLabel = action.payload.label;
      state.backSourcePath = action.payload.path;
      state.backSourceSearchId = action.payload.searchId ?? null;
      state.backSourceNavState = action.payload.navState ?? null;
    },
    clearDocListBackNavigation(state) {
      state.backSourceLabel = null;
      state.backSourcePath = null;
      state.backSourceSearchId = null;
      state.backSourceNavState = null;
    },
    setPrevDocumentListMasterId(state, action: PayloadAction<string>) {
      state.prevDocumentListMasterId = action.payload;
    },
  },
});

export const {
  setDocListId,
  setShowManageColumns,
  setDocListBackNavigation,
  clearDocListBackNavigation,
  setPrevDocumentListMasterId,
} = docListSlice.actions;
export default docListSlice.reducer;
